import type { Track, Vec2 } from '../sim/track';

/** Angle signé le plus court de `from` vers `to` (rad). */
export function angleDiff(from: number, to: number): number {
  return Math.atan2(Math.sin(to - from), Math.cos(to - from));
}

/**
 * Point de visée : avance de `lookAhead` px d'arc le long de la centerline depuis `idx`.
 * Renvoie le point et l'index atteint. (Suivi de trajectoire « pure pursuit » simplifié.)
 */
export function lookAheadPoint(track: Track, idx: number, lookAhead: number): { point: Vec2; idx: number } {
  const s = track.samples;
  const n = s.length;
  let acc = 0;
  let i = idx;
  // Au plus n pas (sécurité anti-boucle si lookAhead dépasse la longueur du tour).
  for (let guard = 0; guard < n && acc < lookAhead; guard++) {
    acc += s[i].segLen;
    i = (i + 1) % n;
  }
  return { point: { x: s[i].x, y: s[i].y }, idx: i };
}

/** Braquage [-1..1] pour viser `target` : proportionnel à l'erreur d'angle, amorti par le lacet. */
export function steerToward(
  car: { x: number; y: number; angle: number; angularVelocity: number },
  target: Vec2,
  kSteer: number,
  kDamp: number,
): number {
  const desired = Math.atan2(target.y - car.y, target.x - car.x);
  const err = angleDiff(car.angle, desired);
  const steer = kSteer * err - kDamp * car.angularVelocity;
  return steer < -1 ? -1 : steer > 1 ? 1 : steer;
}
